export default __webpack_public_path__ + "assets/img/ic-rotate.a5e16a486daf05b77772c36c9bc80134.svg";